import { CommonState } from '@pec/aion-ui-core/slices/common';
import { AutoAcceptStatusPayload } from '../interfaces/autoAccept';
import { TransactionErrorType } from '../interfaces';
import { Actions } from '../actions/autoAccept';

import {
  CLEAR_AUTO_ACCEPT_ERRORS_REQUEST,
  CLEAR_AUTO_ACCEPT_ERRORS_SUCCESS,
  CLEAR_AUTO_ACCEPT_ERRORS_FAILURE,
  FETCH_AUTO_ACCEPT_REQUEST,
  FETCH_AUTO_ACCEPT_STATUS_FAILURE,
  FETCH_AUTO_ACCEPT_STATUS_REQUEST,
  FETCH_AUTO_ACCEPT_STATUS_SUCCESS,
  FETCH_AUTO_ACCEPT_SUCCESS,
  UPDATE_AUTO_ACCEPT_REQUEST,
  UPDATE_AUTO_ACCEPT_SUCCESS,
  UPDATE_AUTO_ACCEPT_FAILURE,
  FETCH_AUTO_ACCEPT_FAILURE
} from '../constants/autoAccept';

export type State = CommonState & {
  status: boolean;
  autoAcceptStatus: AutoAcceptStatusPayload;
};

const initialState: State = {
  isFetching: false,
  status: false,
  error: null,
  autoAcceptStatus: {
    success: true,
    error: {
      code: TransactionErrorType.Internal,
      description: '',
      date: ''
    }
  }
};

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case FETCH_AUTO_ACCEPT_REQUEST:
    case UPDATE_AUTO_ACCEPT_REQUEST:
    case CLEAR_AUTO_ACCEPT_ERRORS_REQUEST:
    case FETCH_AUTO_ACCEPT_STATUS_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case FETCH_AUTO_ACCEPT_SUCCESS:
    case UPDATE_AUTO_ACCEPT_SUCCESS:
      return {
        ...state,
        isFetching: false,
        status: action.payload.status
      };
    case FETCH_AUTO_ACCEPT_STATUS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        autoAcceptStatus: action.payload
      };
    case CLEAR_AUTO_ACCEPT_ERRORS_SUCCESS:
      return {
        ...state,
        isFetching: false
      };
    case FETCH_AUTO_ACCEPT_FAILURE:
    case CLEAR_AUTO_ACCEPT_ERRORS_FAILURE:
    case FETCH_AUTO_ACCEPT_STATUS_FAILURE:
    case UPDATE_AUTO_ACCEPT_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    default:
      return state;
  }
}
